import React, { useState, useRef, Fragment } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as proyectAction from "../../store/actions/proyectAction";

const ConfirmDialogDemo = (props,global) => {
    const {t}=useTranslation();
    const [visible, setVisible] = useState(false);
    const toast = useRef(null);

    const accept = () => {
        toast.current.show({ severity: 'info', summary: t('Confirmed'), detail: t('You have accepted'), life: 3000 });
        props.onClickAction(true);
    }

    const reject = () => {
        toast.current.show({ severity: 'info', summary: t('Rejected'), detail: t('You have rejected'), life: 3000 });
    }

    return (
        <Fragment>
            <Toast ref={toast} />
            <ConfirmDialog visible={visible} 
                onHide={() => setVisible(false)} 
                message={t("Are you sure you want to proceed?")}
                header={t("Confirmation")} 
                icon="pi pi-exclamation-triangle" 
                acceptLabel={t("Si")}
                rejectLabel={t("No")}
                accept={()=>accept()} 
                reject={()=>reject()} />
            <Button className={"p-link layout-menu-button"} 
                onClick={() => setVisible(true)}
                tooltip={t("Resetear posiciones de graficas")} 
                tooltipOptions={{position: 'left',className: "hoverClass",}}
            > 
                
                <i className="pi pi-refresh"></i>
                <label className="fontFamily marginLeft10px">{t("Resetear")}</label>
            </Button>
        </Fragment>
    )
}

const mapStateToProps = (rootReducer) => {
    return {global: rootReducer.proyect};
};
export default connect(mapStateToProps, proyectAction)(withTranslation ("translations") (ConfirmDialogDemo));
